import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  Divider,
  DividerOrientation,
} from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  Icon,
  IconSize,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import {
  DEFAULT_DATE_FORMAT,
  formatDate,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';
import { useInvoiceContext } from '@app/feature/invoice/invoice.context';

export const InvoicingDatesCardComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const invoice = useInvoiceContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  const billingPeriod = invoice.periodStart
    ? `${formatDate(invoice.periodStart, i18n, DEFAULT_DATE_FORMAT)}${invoice.periodEnd ? ` - ${formatDate(invoice.periodEnd, i18n, DEFAULT_DATE_FORMAT)}` : ''}`
    : '-';

  return (
    <Card gap={GapEnum.XL} direction="row" justifyContent="space-between">
      <Stack gap={GapEnum.XS} alignItems="center" flex={1}>
        <Stack gap={GapEnum.XS} alignItems="center" flex={1}>
          <Icon name="building-01" iconSize={IconSize.Small} />
          <Text
            fontSize={TextFontSize.Small}
            color={TextColor.Secondary}
            uppercase>
            {t('$.invoice-details.invoicing-dates.issued-at')}
          </Text>
        </Stack>
        <Text>
          {invoice.issuedAt
            ? formatDate(invoice.issuedAt, i18n, DEFAULT_DATE_FORMAT)
            : '-'}
        </Text>
      </Stack>

      <Divider orientation={DividerOrientation.Vertical} />

      <Stack gap={GapEnum.XS} alignItems="center" flex={1}>
        <Stack gap={GapEnum.XS} alignItems="center" flex={1}>
          <Icon name="building-01" iconSize={IconSize.Small} />
          <Text
            fontSize={TextFontSize.Small}
            color={TextColor.Secondary}
            uppercase>
            {t('$.invoice-details.invoicing-dates.billing-period')}
          </Text>
        </Stack>
        <Text>{billingPeriod}</Text>
      </Stack>
    </Card>
  );
};
